import React, { Component } from 'react';
import {
  BrowserRouter,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom'
import Home from './Home.js';
import Guides from './Guides.js';
import Reference from './reference/Reference.js';
import Downloads from './Downloads.js';
import './App.css';

class App extends Component {
    render() {
        var homeRoute = <Route exact path="/" component={Home}/>
        var navItems = [
            {title: "Guides", link: "/guides"},
            {title: "Reference", link: "/reference"},
            {title: "Downloads", link: "/downloads"}
        ];

        if (process.env.NODE_ENV === "production") {
            // Remove guides and home page
            navItems.splice(0, 1);
            homeRoute = <Route exact path="/" render={() => (
                <Redirect to="/reference" />
            )}/>;
        }

        return (
            <BrowserRouter>
                <div>
                    <nav className="navbar navbar-expand-md navbar-dark fixed-top">
                        <div className="container">
                            <Link to="/" title="HappyCo Developers" className="navbar-brand">
                                <img src={require('./logo.svg')} height="48" alt="" />
                            </Link>
                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className="collapse navbar-collapse" id="navbarsExampleDefault">
                                <ul className="navbar-nav mr-auto">
                                    {navItems.map((navItem) => (
                                        <li className="nav-item">
                                            <Link to={navItem.link} className="nav-link">{navItem.title}</Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </nav>

                    <Switch>
                        {homeRoute}
                        <Route path="/guides" component={Guides}/>
                        <Route path="/reference" component={Reference} />
                        <Route exact path="/downloads" component={Downloads}/>
                    </Switch>

                    <footer className="footer mt-5">
                        <div className="container">
                            <p>&copy; HappyCo 2021</p>
                        </div>
                    </footer>
                </div>
            </BrowserRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js